{
    "MainmenuPinmenu": "Pin-menu",
    "MainmenuPinnedmenu": "Menu losmaken",
    "MainmenuHome": "EVAD Home",
    "MainmenuMoreoptions": "Afdrukuitvoeropties",
    "MainmenuWhatisnew": "Wat is er nieuw?",
    "MainmenuOmnichannelPanel": "Omnichannel-paneel",
    "MainmenuPrivacynotice": "Privacyverklaring",
    "MainMenuCookiePolicy": "Cookie beleid",
    "MainmenuTermsofservice": "Servicemelding:",
    "MainmenuSetlanguage": "Taal instellen",
    "MainmenuHelp": "Helpen?",
    "MainmenuChangePassword": "Verander wachtwoord",
    "MainmenuServerInfo": "Serverinfo",
    "MainmenuSendfeedback": "Zet je bestanden hier neer...",
    "MainmenuButtonTitleAddreport": "Nieuw rapport toevoegen",
    "MainmenuButtonTitleDeletereport": "Rapport verwijderen",
    "MainmenuButtonTitlePermanentlyDeletereport": "Rapport permanent verwijderen",
    "MainmenuButtonSubTitleDisabled": "(Selecteer enkele rapporten om deze optie te gebruiken)",
    "NAME": "LanguageMainMenu",
    "MainMenu_RestartTour": "De tour opnieuw starten",
    "MAIN_MENU_SETTINGS_CLEAR_CONTENTFUL_CACHE": "Inhoudscache wissen",
    "MainMenu_Turn_On_Insights_Hub": "Dashboard Insights inschakelen",
    "MainMenu_Turn_Off_Insights_Hub": "Dashboard Insights uitschakelen",
    "MainMenu_Timezone": "Tijdzone wijzigen"
}